module.exports = __webpack_public_path__ + "static/media/Message.28e22910.svg";